var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthrsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.617,
    height: 24.496,
    viewBox: "0 0 24.617 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M9.475,5.191h0A3.066,3.066,0,1,0,5.067.928L3.846,2.188A13.24,13.24,0,0,0,2.612,19.4a13.208,13.208,0,0,0,1.28,1.439,12.989,12.989,0,0,0,18.371-.31l1.491-1.544a3.066,3.066,0,0,0-4.408-4.263l-1.491,1.544A6.867,6.867,0,0,1,7.172,15.241a7,7,0,0,1,.99-8.677L9.495,5.184H9.488Z",
    transform: "translate(0.002 0.007)",
    fill: "#b9b9b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthrsIcon);
export default __webpack_public_path__ + "static/media/othrsIcon.14d669ff12a340da4130b767b4989534.svg";
export { ForwardRef as ReactComponent };